import { useMemo } from "react";
import IconButton from "@shared/v2/IconButton";
import { TrashSolidV6 } from "@shared/v2/Icomoon";
import Dropdown from "@shared/v2/Dropdown";

const RolesRow = ({
  allAssignableAgents,
  allAssignableRoles,
  availableRoles,
  handleAddAgent,
  handleAddRole,
  handleRemoveAgent,
  selectedTeamMembers,
}) => {
  const teamMemberOptions = useMemo(
    () =>
      allAssignableAgents.map((agent) => ({
        label: agent.name,
        value: agent.agent_id,
        meta: agent,
      })),
    [allAssignableAgents],
  );
  const allRoleOptions = useMemo(
    () => allAssignableRoles.map(({ id, title }) => ({ label: title, value: id })),
    [allAssignableRoles],
  );
  const roleOptions = useMemo(
    () =>
      availableRoles
        .map((role) => ({
          label: role.title,
          value: role.id,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [availableRoles],
  );

  return selectedTeamMembers.map((selectedTeamMember, i) => {
    if (selectedTeamMember.destroy) return null;
    const teamMemberOption = teamMemberOptions.find((tm) => tm.value === selectedTeamMember.agent_id);
    const selectedOption = allRoleOptions?.find((option) => option.value === selectedTeamMember.role_id);
    return (
      // eslint-disable-next-line react/no-array-index-key
      <div key={i} className="tw-flex tw-items-end tw-gap-[16px]">
        <Dropdown
          containerClassName="tw-flex-1"
          label="Team Member"
          isSearchable={!selectedTeamMember?.id}
          isClearable={false}
          placeholder={teamMemberOption?.label || "Select a team member"}
          value={teamMemberOption || null}
          options={teamMemberOptions}
          onChange={(option) => handleAddAgent(option.meta, i)}
          isDisabled={Boolean(selectedTeamMember?.id)}
          menuShouldComeToFront
        />

        <Dropdown
          containerClassName="tw-flex-1"
          label="Role"
          isSearchable
          isClearable={false}
          placeholder="Select a Role"
          value={selectedOption || null}
          options={selectedOption ? [selectedOption, ...roleOptions] : roleOptions}
          onChange={(e) => handleAddRole(e.value, i)}
          menuShouldComeToFront
        />

        <IconButton
          id="delete-button"
          schema="transparent"
          onClick={() => handleRemoveAgent(selectedTeamMember.agent_id, selectedTeamMember.role_id)}
        >
          <TrashSolidV6 />
        </IconButton>
      </div>
    );
  });
};

export default RolesRow;
